import { Avatar, Card, CardContent, Stack, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const CommunityBusinessTypeCard = ({ code, icon, title, handleOnChange, currentBusinessType, ...props}) => {
    const { t } = useTranslation();
    const [selected, setSelected] = useState(currentBusinessType === code);
    const theme = useTheme();

    const handleClick = () => {
        setSelected(!selected);
        handleOnChange(code);
    }

    const checkBoxColor = props.disabled ? theme.palette.disabled : theme.palette.primary.main;

    useEffect(() => {
        setSelected(currentBusinessType === code);
    }, [currentBusinessType, code]);

    return (
        <Card id={`card_${code}`} key={code} variant="outlined" onClick={handleClick}
            sx={{
                cursor: props.disabled ? "default" : "pointer",
                width: "100%",
                height: "100%",
                position: "relative",
                borderColor: selected ? "primary.main" : "grey.300",
                bgcolor: selected ? "primary.main" : "disabled",
                color: selected ? "white" : "default",
                ...props.sx || {}
            }}
        >
            <CardContent>
                <Stack spacing={2}>
                    <Avatar  sx={{
                        bgcolor: selected ? "white" : checkBoxColor,
                        color: selected ? checkBoxColor : "white" }}>{icon}</Avatar>
                    <Typography variant="h6">{t(title)}</Typography>
                </Stack>
            </CardContent>
        </Card>
    )
}

export default CommunityBusinessTypeCard;